<template>
    <div class="w-full">
        <div class="mb-4">
            <label for="descrizione"
                   class="block text-gray-800 font-bold text-sm py-2 w-full">
                Descrizione
            </label>
            <div class="flex items-center">
                <input type="text"
                       class="shadow appearance-none border rounded px-2 py-3 w-4/5 mr-4"
                       id="descrizione"
                       name="descrizione"
                       v-model="descrizione"
                       placeholder="metti una descrizione ...">
                <button @click="createFix"
                        class="bg-aitems-700 hover:bg-aitems-700-dark text-white font-bold py-3 px-4 rounded w-1/5">
                    Crea Fissaggio
                </button>
            </div>
        </div>
        <div class="w-full flex">
            <div class="w-1/2">
                <p class="block text-sm font-bold text-gray-800 py-2 mb-2">
                    Componenti
                </p>
                <ul class="list-reset shadow">
                    <li class="border rounded font-thin text-sm tracking-wide p-2 cursor-pointer"
                        v-for="item in items"
                        v-text="item.id_articolo + ' - ' + item.descrizione"
                        @dblclick="move(item)"
                    >

                    </li>
                </ul>
            </div>
            <div class="w-1/2 ml-4">
                <p class="block text-sm font-bold text-gray-800 py-2 mb-2">Fissaggio</p>
                <ul class="list-reset shadow">
                    <li class="border rounded font-thin text-sm text-gray-800 tracking-wide p-2 bg-green-lighter"
                        v-for="fix in fixes"
                        v-text="fix.id_articolo + ' - ' + fix.descrizione">

                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['item'],

        data() {
            return {
                items: [],
                fixes: [],
                descrizione: ''
            }
        },

        created() {
            axios.get('/items?type=componenti')
                .then((response) => this.items = response.data);
        },

        methods: {
            move(item) {
                this.fixes.push(item);
            },

            createFix() {
                swal.fire({
                    title: 'Sei sicuro?',
                    text: 'Stai per Fissare un componente che non si muoverà mai più',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Fissa Tutto!'
                }).then(({value}) => {
                    if (value) {
                        axios.post('/items/' + this.item.id_articolo + '/fixing', this.$data)
                            .then(({data: {redirect}}) => {
                                location.assign(redirect);
                            });
                    } else {
                        console.log('Mi sono dimesso Tutto!');
                    }
                });
            }
        }

    }
</script>